import { render, staticRenderFns } from "./MeetingClosureFridge.vue?vue&type=template&id=906f6090&"
import script from "./MeetingClosureFridge.vue?vue&type=script&lang=js&"
export * from "./MeetingClosureFridge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports